import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  visible: boolean;
  onAcceptAll: () => void;
  onRejectAll: () => void;
  localeOverride?: 'en' | 'pl' | 'de' | 'fr' | 'it';
};

const ConsentBanner: React.FC<Props> = ({ visible, onAcceptAll, onRejectAll, localeOverride }) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (localeOverride) {
      i18n.changeLanguage(localeOverride);
    }
  }, [localeOverride, i18n]);

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50">
      <div className="container-custom pb-4">
        <div className="rounded-lg border border-gray-200 bg-white text-black shadow-lg">
          <div className="p-4 sm:p-6">
            <h2 className="text-base sm:text-lg font-semibold mb-2">{t('cookies.title')}</h2>
            <p className="text-sm sm:text-base text-gray-700 mb-4">{t('cookies.description')}</p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <button
                type="button"
                onClick={onAcceptAll}
                className="inline-flex items-center justify-center rounded-md bg-orange-accent px-4 py-2 text-white font-medium hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-accent"
              >
                {t('cookies.acceptAll')}
              </button>
              <button
                type="button"
                onClick={onRejectAll}
                className="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-gray-900 font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300"
              >
                {t('cookies.decline')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;


